/**
 * Silent background provider profile refresh client.
 */

import { authHttp } from "./auth-http";

/**
 * Supported external identity providers.
 */
export type AuthProviderId = "swisspass";

/**
 * Triggers a silent background provider profile refresh for the authenticated
 * user. The request is best-effort: any failure is ignored by the caller.
 *
 * @param type - Provider whose stored profile should be refreshed.
 */
export async function updateProviderProfile( type: AuthProviderId ): Promise<void> {
    await authHttp.post( "/api/auth/provider_profile", { type } );
}
